import React, { useState, useContext } from "react"
import SwipeableBottomSheet from 'react-swipeable-bottom-sheet';
import { PolicySummary } from "./PolicySummary";
import FlexView from "react-flexview/lib";
import { GreenButton } from "../Core/Buttons/GreenButton";
import { InsurancePurchaseContextStore } from "../../context/InsuracePurchaseContext";
import { FirebaseService, FirebaseConfigKey } from "../../services/FirebaseService";
import InfoIcon from '@material-ui/icons/Info';
import { Collapse, useMediaQuery } from "@material-ui/core";
import { GetAQuotePopup } from "../Quote/GetAQuotePopup";
import { useLocation } from "react-router-dom";
import './BottomSheetPolicySummary.scss'
import { UserProfileContextStore } from "../../context/UserProfileContext";

export const BottomSheetPolicySummary = (props) => {
    const [policySummaryOpenMobile, setPolicySummaryOpenMobile] = useState(false)
    const insuranceContext = useContext(InsurancePurchaseContextStore)
    const { hasError } = useContext(UserProfileContextStore);
    const location = useLocation()
    const [showOverflowTop, setShowOverflowTop] = useState(false)
    const isMobileByWidth = !useMediaQuery(theme => theme.breakpoints.up('md'));

    const toggleBottomSheet = () => {
        setPolicySummaryOpenMobile(!policySummaryOpenMobile)
    }

    const openBottomSheet = (open) => {
        setPolicySummaryOpenMobile(open)
    }

    const onGreenButtonClick = e => {
        e.stopPropagation()
        props.onClick()
    }

    const onTransitionEnd = () => {
        setShowOverflowTop(policySummaryOpenMobile)
    }

    const padding = isMobileByWidth

    return (
        <SwipeableBottomSheet style={{zIndex: 999}} swipeableViewsProps={{onTransitionEnd: onTransitionEnd}} 
            open={policySummaryOpenMobile} onChange={openBottomSheet} shadowTip={false} overflowHeight={isMobileByWidth ? 86 : 96}>
            <Collapse in={!showOverflowTop}>
                <div onClick={toggleBottomSheet} style={{height: 74, paddingTop: isMobileByWidth ? 15 : 6, paddingLeft: isMobileByWidth ? 8 : 6}}>
                    {location.pathname.startsWith('/insurance/profile') && hasError && <div className="red">{hasError}</div> }
                    <FlexView vAlignContent={'center'} className="space-between margin-top-small">

                        <div>
                            {!location.pathname.startsWith('/proposal') && <GetAQuotePopup />}
                            <FlexView className="margin-top-3">
                                <div className="text-body black italic">Price:</div>
                                <FlexView vAlignContent={'center'} className="text-body margin-left-3 black bold">{FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{insuranceContext.selectedOption.finalPrice}</FlexView>
                            </FlexView>
                        </div>
                        <GreenButton className="continue-button-mobile" onClick={onGreenButtonClick}>{props.title}</GreenButton>
                        <div/>
                    </FlexView>
                </div>
            </Collapse>
            <FlexView hAlignContent={'center'}>
                <PolicySummary className="mobile-policy-summary-card"
                    mobileExtension={<FlexView hAlignContent={'center'}>
                                    <GreenButton onClick={onGreenButtonClick}>{props.title}</GreenButton>
                                </FlexView>} />  
            </FlexView>
        </SwipeableBottomSheet>
    )
}